import React from 'react';
import wucImage from '../../assets/img/websiteUnderConstruction.png';
import Button from '../../components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
import './ComingSoonPage.css';

export default function ComingSoon() {
  return (
    <div className='wuc-div'>
      <img src={wucImage} alt='Website under construction' />
      <Link to='/categories' style={{ textDecoration: 'none' }}>
        <Button color='info' round>
          Go Back
        </Button>
      </Link>
    </div>
  );
}
